import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["translations"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Team, TestIdProvider } from '@ori/testid-generator';
import { ThemeProvider } from '@ori-ui/mui';
import { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { DialogContainer } from './DialogContainer';
import { ErrorBoundary } from './ErrorBoundary';
import { i18n } from '../translations';
import { jsx as _jsx } from "react/jsx-runtime";
export var ProductInfoDialog = function ProductInfoDialog(props) {
  var translations = props.translations,
    containerProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(I18nextProvider, {
        i18n: i18n(translations),
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          enableCacheProvider: true,
          cacheKey: "product-info-dialog",
          children: /*#__PURE__*/_jsx(TestIdProvider, {
            team: Team.Presentation,
            project: "product-info-dialog",
            children: /*#__PURE__*/_jsx(DialogContainer, _objectSpread({}, containerProps))
          })
        })
      })
    })
  });
};